import { useEffect, useRef } from 'react';
import { Box, Stack, Typography } from 'ui';
import { ImageOutlined } from 'ui/icons';

import type { PreviewGalleryImage } from '../../types';
import { PreviewImage } from '../PreviewImage/PreviewImage';

interface PreviewGalleryProps {
  images: PreviewGalleryImage[];
  onClick?: (image: PreviewGalleryImage) => void;
  isPortrait: boolean;
}

export const PreviewGallery = ({ images = [], onClick, isPortrait }: PreviewGalleryProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollContainerRef.current && images.length > 0) {
      const scrollContainer = scrollContainerRef.current;
      const scrollPosition = isPortrait ? scrollContainer.scrollWidth : scrollContainer.scrollHeight;

      scrollContainer.scrollTo({
        [isPortrait ? 'left' : 'top']: scrollPosition,
        behavior: 'smooth',
      });
    }
  }, [images.length, isPortrait]);

  return (
    <Stack
      direction={isPortrait ? 'row' : 'column'}
      sx={{
        alignItems: 'center',
        height: isPortrait ? '100%' : undefined,
        width: isPortrait ? undefined : '100%',
        paddingLeft: isPortrait ? 2 : 0,
        paddingRight: isPortrait ? 2 : 0,
        paddingTop: isPortrait ? 0 : 2,
        paddingBottom: isPortrait ? 0 : 2,
        color: 'white',
      }}
      spacing={1}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Typography color="white">{images.length}</Typography>
        <ImageOutlined />
      </Box>
      <Box
        ref={scrollContainerRef}
        sx={{
          padding: 1,
          overflowX: isPortrait ? 'auto' : 'hidden',
          overflowY: isPortrait ? 'hidden' : 'auto',
          width: isPortrait ? '100%' : undefined,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: isPortrait ? 'row' : 'column',
            gap: 2,
            minWidth: 'max-content',
          }}
        >
          {images.map((image, i) => (
            <Box
              onClick={() => onClick?.(image)}
              key={i}
              sx={{
                position: 'relative',
                flexShrink: 0,
                height: 50,
                marginRight: 0.5,
                width: 50,
              }}
            >
              <PreviewImage image={image} isPortrait={isPortrait} />
            </Box>
          ))}
        </Box>
      </Box>
    </Stack>
  );
};
